import styled from "styled-components";

export const FormGroup = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  line-height: 28px;
  color: #34325e;
`;

export const FormLabel = styled.label`
  font-weight: bold;
  line-height: 28px;
  padding-bottom: 5px;
`;

export const FormInput = styled.input`
  border: 1px solid #c4c4c4;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 5px;
`;
